import { HttpHeaders } from '@angular/common/http';

/**
 * Merges a list of HttpHeaders into one and new and single HttpHeaders instance
 * @param headerList - The list of HttpHeaders to be merged
 * @returns HttpHeader instance
 */
export function mergeHttpHeaders(...headerList: HttpHeaders[]) {
  const allHeaders = headerList.reduce((acc, headers) => {
    // merge all keys of each instance
    return { ...acc, ...headers.keys().reduce((innerAcc, key) => ({ ...innerAcc, [key]: headers.get(key) }), {}) };
  }, {});
  return new HttpHeaders(allHeaders);
}
